












import { Component, Vue, Watch } from 'vue-property-decorator';
import Layer from '@/components/service/InsLayer.vue';
import { FrontE } from '@/sdk/common/SysConst';
@Component({
  components: {
    Layer
  }
})
export default class App extends Vue {
  get isMobile () {
    return this.$store.state.isMobile;
  }

  get lang () {
    return this.$i18n.locale;
  }
  
  mounted() {
    Vue.prototype.$ShowLayer();
    setTimeout(() => {
      Vue.prototype.$HiddenLayer();
    }, 1500);
  }
  beforeUpdate() {
    if (this.$route.name !== 'home') {
      return;
    }
    if (this.$route.query.returnUrl) {
      let url = this.$route.query.returnUrl + '?';
      Object.keys(this.$route.query).forEach(e => {
        if (e !== 'returnUrl') url += e + '=' + this.$route.query[e] + '&';
      });
      this.$router.push(url);
    } else {
      this.$nextTick(() => {
        this.$Api.promotion.GetHomeSeoData().then(result => {
          document.title = result.Data.Title;
        });
      });
    }
  }
  beforeCreate() {
    if (!window['MemberApi']) window['MemberApi'] = this.$Api.member;
  }

  disBuilding () {
    if (!this.isMobile && (FrontE.pcBuilding) && this.$route.name !== 'building') {
      this.$router.push('/building');
    } else if (this.isMobile && (FrontE.mobileBuilding) && this.$route.name !== 'building') {
      this.$router.push('/building');
    }
  }

  created () {
    this.disBuilding();
  }

  @Watch('isMobile')
  onMediaChange () {
    this.disBuilding();
  }
}
